import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { logout } from "store/actions/auth";
import CommonService from "services/common";
import JobService from "services/jobAd";
import DashboardView from "./view";

class Admin extends Component {
  state = {
    mode: "jobAds",
    jobs: [],
    forms: [],
    accountDeleteModal: false,
    logo: {},
    type: "company",
  };

  componentDidMount() {
    const { history, user } = this.props;

    if (!user.token || user.type !== "company") history.push("/");
    else {
      this.getJobs();
    }
  }

  getJobs = () => {
    const { user } = this.props;
    const companyID = user.id;

    JobService.getJobsByCompany(companyID).then((res) => {
      if (res) this.setState({ jobs: res });
    });
  };

  selectMode = (mode) => this.setState({ mode });

  deleteAccount = () => {
    const { user, history } = this.props;
    CommonService.deleteAccount({ id: user.id, token: user.token }).then(
      (res) => {
        if (res === "success") {
          logout();
          history.push("/");
        }
      }
    );
  };

  showAccountDeleteModal = (accountDeleteModal) =>
    this.setState({ accountDeleteModal });

  setFormData = (type, value) => this.setState({ [type]: value });

  editAccount = () => {};

  render() {
    const { mode, jobs, accountDeleteModal, logo, type, forms } = this.state;
    return (
      <DashboardView
        mode={mode}
        jobs={jobs}
        selectMode={this.selectMode}
        deleteAccount={this.deleteAccount}
        accountDeleteModal={accountDeleteModal}
        showAccountDeleteModal={this.showAccountDeleteModal}
        logo={logo.name}
        editAccount={this.editAccount}
        type={type}
        forms={forms}
      />
    );
  }
}

const mapStateToProps = ({ post, user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));
